module.exports = __webpack_public_path__ + "static/media/segPlastik.4b6974a1.png";